export const ROUTES = {
    home: `/`,
    contactUs: '/contactUs',
    featureList: '/featureList',
    productPricing: '/productPricing',
    businessLogin: '/businessLogin',
    employeeLogin: '/employeeLogin',
    businessCreateAccount: '/businessCreateAccount',
    forgotPassword: '/forgotPassword',
    privacyPolicy: '/policy/privacy',
    cookiePolicy: '/policy/cookies',
    tncPage: '/policy/tnc',
    updateProfile: '/updateProfile',
    businessDashboard: '/business/dashboard',
    employeeDashboard: '/employee/dashboard',
    menu: '/menu',
    subscriptionRenew: '/subscriptionRenew',
    business: {
        list: '/business/list',
        addBusiness: '/business/newBusiness',
        detail: '/business/details'
    },
    location: {
        list: '/location/list',
        add: '/location/newLocation',
        detail: '/location/details'
    },
    employee: {
        list: '/employee/list',
        add: '/employee/addEmployee',
        detail: '/employee/details',
        selectLocation: '/employee/selectLocation',
        changePassword: '/employee/changePassword',
        clockIn: '/employee/clockIn'
    },
    attendace: {
        list: '/attendance/list',
    },
    project: {
        list: '/project/list',
        addProject: '/project/add',
        detail: '/project/details'
    },
    shift: {
        list: '/shift/list',
        add: '/shift/add',
        detail: '/shift/details'
    },
    task: {
        list: '/task/list',
        add: '/task/add',
        detail: '/task/details'
    },
    message: {
        list: '/task/list',
        add: '/task/add'
    },
    documents: {
        list: '/documents/list',
        details: '/documents/detail',
        add: '/documents/new'
    },
    policies: {
        list: '/policy/list',
        add: '/policy/addPolicy',
        details: '/policy/detail'
    },
    timeOff: {
        list: '/timeOff/list',
        add: '/timeOff/addTimeOff',
        detail: '/timeOff/details'
    },
    requests: {
        list: '/request/list',
        detail: '/request/details',
        add: '/request/add',
        employeeRequest: '/request/employeeRequests'
    },
    assets: {
        list: '/asset/list',
        add: '/asset/add',
        detail: '/asset/detail',
        edit: '/asset/edit'
    },
    performance: {
        menu: '/performance/options',
        feedbackList: '/performance/feedbacks',
        requestList: '/performance/requests',
        newRequest: '/performance/newRequest',
        goalList: '/performance/goals',
        newGoal: '/performance/newGoal',
        goalDetail: '/performance/goalDetail'
    },
    payroll: {
        menu: '/payroll/options',
        payslipList: '/payroll/payslip/list',
        newPayroll: '/payroll/new',
        taxRules: '/payroll/taxRules',
        payslipDetail: '/payroll/payslip/detail'
    },
    audit: {
        logs: '/audit/logs',
        details: '/audit/detail',
        newLog: '/audit/newLog'
    },
    visitor: {
        checkIn: '/visitor/checkIn',
        book: '/visitor/book',
        settings: '/visitor/settings',
        entryQR: '/visitor/entryQR',
        menu: '/visitor/options'
    },
    notificationList: '/notificationList',
    profile: '/profile',
    messageList: '/messageList',
    messageChatList: '/messageChatList',
    admin: {
        userList: '/admin/userList',
        businessList: '/admin/businessList',
        subscriptionList: '/admin/subscriptionList',
        newSubscription: '/admin/newSubscription',
        contactUsList: '/admin/contactUsRecords'
    },
    supplies: {
        menu: '/supplies/options',
        merchant: {
            list: '/supplies/merchant/list',
            detail: '/supplies/merchant/detail',
            newMerchant: '/supplies/merchant/newMerchant'
        },
        category: {
            list: '/supplies/category/list'
        },
        item: {
            catList: '/supplies/item/catList',
            list: '/supplies/item/list',
            detail: '/supplies/item/detail',
            newItem: '/supplies/item/newItem'
        }
    }
}

export const API_CONSTANTS = {
    SUCCESS_STATUS: 'SUCCESS_STATUS',
    ERROR_STATUS: 'ERROR_STATUS'
}

export const ORGANISATION_DETAIL = {
    ORGANISATION_NAME: 'Togethra LLC',
    ORG_ADDRESS_LINE2: 'Haryana, India',
    ORG_SUPPORT_EMAIL: 'support@gomobites.com'
}

export const APP_CONSTANTS = {
    UNAUTHORIZE_TO_PERFORM_OPERATION_MSG: 'You are not authorized to perform this operation',
    PRODUCT_NAME: 'TOGETHRA',
    USER: 'USER',
    USER_TOKEN: 'USER_TOKEN',
    LOGOUT: 'LOGOUT',
    RESET_STATE_CITY: 'RESET_STATE_CITY',
    DISPLAY_COOKIE_CONSENT: 'DISPLAY_COOKIE_CONSENT',
    DISPLAY_NEWS_LETTER_CONSENT: 'DISPLAY_NEWS_LETTER_CONSENT',
    MENU_ITEM_TYPE: {
        OPERATOR_LIST: 'OPERATOR_LIST',
        OFFER_LIST: 'OFFER_LIST',
        RECEIPT_LIST: 'RECEIPT_LIST',
        INVOICE_LIST: 'INVOICE_LIST',
        CASHBACK_LIST: 'CASHBACK_LIST',
        PROFILE: 'PROFILE'
    },
    MENU_ITEM_DISPLAY_NAME: {
        OPERATOR_LIST: 'Operators',
        OFFER_LIST: 'Offers',
        INVOICE_LIST: 'Invoices',
        RECEIPT_LIST: 'Receipts',
        CASHBACK_LIST: 'Cashback Requests',
        CUSTOMER_CASHBACK_LIST: 'Cashback Rewards',
        PROFILE: 'Profile',
        LOGOUT: 'Log Out'
    },
    ENVIRONMENT: {
        LOCAL: 'LOCAL',
        LOCAL_CUSTOMER: 'LOCAL_CUSTOMER',
        DEV: 'DEV',
        PROD: 'PROD'
    },
    KEY_FCM_TOKEN: 'KEY_FCM_TOKEN',
    SESSION_EXPIRE_MESSAGE: 'Your session expire. Please try login again',
    COMMON_ERROR: 'COMMON_ERROR',
    EMAIL_ALREADY_SUBSCRIBED_ERROR_MESSAGE: 'Email already subscribed',
    DEVICE_TYPE: {
        ANDROID: 'ANDROID',
        IOS: 'IOS',
        DESKTOP: 'DESKTOP',
        WINDOWS: 'WINDOWS',
        MAC_OS: 'MAC_OS'
    },
    KEY_DEVICE_ID: 'deviceId',
    USER_ROLE_TYPE: {
        ADMIN: 'ADMIN',
        BUSINESS: 'BUSINESS',
        EMPLOYEE: 'EMPLOYEE',
        AGENT: 'AGENT',
        SUPPORT: 'SUPPORT',
        CUSTOMER: 'CUSTOMER'
    },
    CUSTOMER_TYPE: {
        COMMERCIAL: 'COMMERCIAL',
        RESIDENTIAL: 'RESIDENTIAL'
    },
    PROJECT_TYPE: {
        ONLINE: 'ONLINE',
        OFFLINE: 'OFFLINE'
    },
    TASK_STATUS: {
        OPEN: "OPEN",
        IN_PROGRESS: 'IN_PROGRESS',
        HOLD: 'HOLD',
        CLOSED: 'CLOSED'
    },
    TASK_TYPE: {
        GROUP: 'GROUP',
        INDIVIDUAL: 'INDIVIDUAL'
    },
    ATTENDANCE_TYPE: {
        DAY_START: 'DAY_START',
        HALF_DAY: 'HALF_DAY',
        FULL_DAY: 'FULL_DAY',
        DAY_OFF: 'DAY_OFF'
    },
    EMPLOYEE_REQUEST_TYPE: {
        TIME_OFF: 'TIME_OFF',
        SHIFT_SWAP: 'SHIFT_SWAP',
        SICK_DAY: 'SICK_DAY',
        SHIFT_REQUEST: 'SHIFT_REQUEST'
    },
    EMPLOYEE_REQUEST_STATUS_TYPE: {
        PENDING: 'PENDING',
        APPROVED: 'APPROVED',
        REJECTED: 'REJECTED'
    },
    PROJECT_STATUS: {
        NEW: 'NEW',
        PENDING: 'PENDING',
        IN_PROGRESS: 'IN_PROGRESS',
        COMPLETE: 'COMPLETE',
        ON_HOLD: 'ON_HOLD',
        CANCELLED: 'CANCELLED'
    },
    DEFAULT_LOCATION_KEY: 'USA',
    CHAT_TYPE: {
        GROUP: 'GROUP',
        INDIVIDUAL: 'INDIVIDUAL'
    },
    EMPLOYEE_SCREEN_FLOW_TYPE: {
        EMPLOYEES: 'EMPLOYEES',
        ATTENDANCE: 'ATTENDANCE',
        TIME_OFF: 'TIME_OFF',
        MY_TEAM: 'MY_TEAM',
        PAYSLIP_LIST: 'PAYSLIP_LIST'
    },
    SUBSCRIPTION_TYPE: {
        MONTHLY: 'MONTHLY',
        YEARLY: 'YEARLY'
    },
    TRANSACTION_STATUS: {
        PAID: 'PAID',
        ERROR: 'ERROR',
        PENDING: 'PENDING'
    },
    ASSET_STATUS: {
        AVAILABLE: 'AVAILABLE',
        ASSIGNED: 'ASSIGNED',
        MAINTENANCE: 'MAINTENANCE',
        DISPOSED: 'DISPOSED'
    },
    ASSET_ASSIGNMENT_STATUS: {
        ACTIVE: 'ACTIVE',
        RETURNED: 'RETURNED',
        OVERDUE: 'OVERDUE'
    },
    PERFORMANCE_REQUEST_STATUS: {
        PENDING: 'PENDING',
        COMPLETED: 'COMPLETED'
    },
    PERFORMANCE_GOAL_STATUS: {
        NEW: 'NEW',
        IN_PROGRESS: 'IN_PROGRESS',
        COMPLETED: 'COMPLETED',
        ON_HOLD: 'ON_HOLD'
    },
    EMPLOYEE_SALARY_DEDUCTION_TYPE: {
        FIXED: 'FIXED',
        PERCENT: 'PERCENT'
    },
    POLICY_STATUS: {
        PENDING: 'PENDING',
        COMPLETE: 'COMPLETE'
    },
    AUDIT_STATUS: {
        NEW: 'NEW',
        PENDING: 'PENDING',
        IN_PROCESS: 'IN_PROCESS',
        COMPLETED: 'COMPLETED',
        ON_HOLD: 'ON_HOLD'
    },
    AUDIT_LOG_STATUS: {
        SUBMITTED: 'SUBMITTED',
        APPROVED: 'APPROVED',
        CANCELLED: 'CANCELLED'
    },
    SCREEN: {
        EMPLOYEE_LIST: 'EMPLOYEE_LIST',
        ADD_EMPLOYEE: 'ADD_EMPLOYEE',
        PROJECT_LIST: 'PROJECT_LIST',
        ADD_PROJECT: 'ADD_PROJECT',
        SHIFT_LIST: 'SHIFT_LIST',
        ADD_SHIFT: 'ADD_SHIFT',
        TASK_LIST: 'TASK_LIST',
        ADD_TASK: 'ADD_TASK',
        MESSAGE_CHAT_LIST: 'MESSAGE_CHAT_LIST',
        REQUEST_LIST: 'REQUEST_LIST',
        ADD_REQUEST: 'ADD_REQUEST',
        DOCUMENT_LIST: 'DOCUMENT_LIST',
        ADD_DOCUMENT: 'ADD_DOCUMENT',
        POLICY_LIST: 'POLICY_LIST',
        ADD_POLICY: 'ADD_POLICY',
        LOCATION_LIST: 'LOCATION_LIST',
        ASSET_LIST: 'ASSET_LIST',
        ADD_ASSET: 'ADD_ASSET',
        PERFORMANCE_REQUEST_LIST: 'PERFORMANCE_REQUEST_LIST',
        PERFORMANCE_REQUEST_FEEDBACK: 'PERFORMANCE_REQUEST_FEEDBACK',
        PERFORMANCE_GOAL_LIST: 'PERFORMANCE_GOAL_LIST',
        PERFORMANCE_ADD_GOAL: 'PERFORMANCE_ADD_GOAL',
        PERFORMANCE_REVIEW_LIST: 'PERFORMANCE_REVIEW_LIST',
        AUDIT_LIST: 'AUDIT_LIST',
        NEW_AUDIT: 'NEW_AUDIT',
        VISITOR_SETTING_SCREEN: 'VISITOR_SETTING_SCREEN',
        VISITOR_QR_CODE: 'VISITOR_QR_CODE',
        VISITOR_LIST_SCREEN: 'VISITOR_LIST_SCREEN',
        TAX_RULES_LIST: 'TAX_RULES_LIST',
        PAY_SLIP_LIST: 'PAY_SLIP_LIST',
        MERCHANT_LIST: 'MERCHANT_LIST',
        ADD_MERCHANT: 'ADD_MERCHANT',
        SUPPLIES_ITEM_CATEGORIES_LIST: 'SUPPLIES_ITEM_CATEGORIES_LIST',
        ADD_SUPPLIES_ITEM_CATEGORIES: 'ADD_SUPPLIES_ITEM_CATEGORIES',
        SUPPLIES_ITEM_CAT_LIST: 'SUPPLIES_ITEM_CAT_LIST',
        SUPPLIES_ITEM_LIST: 'SUPPLIES_ITEM_LIST',
        ADD_SUPPLIES_ITEM: 'ADD_SUPPLIES_ITEM'
    }

}